const getWebInitTimestamp = () => {
  var _performance_timing, _performance, _performance1;
  return ((_performance = performance) === null || _performance === void 0 ? void 0 : (_performance_timing = _performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart) || ((_performance1 = performance) === null || _performance1 === void 0 ? void 0 : _performance1.timeOrigin);
};
const attachErrorTimestamp = (error) => {
  let duration = 0;
  try {
    performance.mark("error");
    duration = performance.measure("navigationStart_to_error", "navigationStart", "error").duration;
    performance.clearMarks("error");
    performance.clearMeasures("navigationStart_to_error");
  } catch (e) {
    duration = Date.now() - getWebInitTimestamp();
  }
  if (typeof error === "object") {
    error._triggerTime = duration;
  }
};
const attachErrorTimestampForEvent = (event) => {
  try {
    const { error } = event;
    attachErrorTimestamp(error);
  } catch (e) {
  }
};
const hijackConsoleError = () => {
  var _console;
  if ((_console = console) === null || _console === void 0 ? void 0 : _console.error) {
    const defaultError = console.error;
    console.error = (error, ...args) => {
      attachErrorTimestamp(error);
      defaultError.apply(void 0, [
        error,
        ...args
      ]);
    };
  }
};
const bindTimestampHandler = () => {
  if (!window._bound_error_time) {
    window._bound_error_time = true;
    if (process.env.NODE_ENV === "development") {
      window.addEventListener("error", attachErrorTimestampForEvent, true);
    } else {
      hijackConsoleError();
    }
  }
};
export {
  bindTimestampHandler,
  getWebInitTimestamp
};
